import { render, staticRenderFns } from "./ReservationInfoPopup.vue?vue&type=template&id=4550c0c6&"
import script from "./ReservationInfoPopup.vue?vue&type=script&lang=js&"
export * from "./ReservationInfoPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports